import styled from '@emotion/styled'

export const StyleBannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 900px) {
    flex-flow: row wrap;
    row-gap: 20px;
  }
`

export const StyleHalfBanner = styled.div`
  width: 49%;
  @media (max-width: 900px) {
    width: 100%;
  }
`
